var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.type === "seaport"
    ? _c("cargo-advance-select", {
        attrs: {
          "default-value": _vm.multiple ? "" : _vm.selectValue,
          url: _vm.url.seaport.portList,
          headers: ["CODE", "名称"],
          fields: ["code", "chineseName"],
          "callback-params": { key: "seaport" },
          "remote-default-obj": _vm.remoteDefaultObj,
          "tag-value": "code",
          "tag-name": "code",
          disabled: _vm.disabled,
          remote: "",
          placeholder: _vm.placeholder
        },
        on: { parentCallBack: _vm.getItemFromChild }
      })
    : _vm.type === "airport"
    ? _c("cargo-advance-select", {
        attrs: {
          "default-value": _vm.multiple ? "" : _vm.selectValue,
          url: _vm.url.mdm.airport.port,
          headers: ["CODE", "名称"],
          fields: ["code", "chineseName"],
          "callback-params": { key: "airport" },
          "remote-default-obj": _vm.remoteDefaultObj,
          "tag-value": "code",
          "tag-name": "code",
          disabled: _vm.disabled,
          remote: "",
          placeholder: _vm.placeholder
        },
        on: { parentCallBack: _vm.getItemFromChild }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }